import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref, watch} from "vue";
import {useGajiListModel} from "@/stores/models/gaji-list-model";

export const useGajiListStore  = defineStore(
    'gajiListStore',
    () => {
        const gajiPeriodeId = ref(null);

        const isLoading = ref(false);
        const dataSourceGajiList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiListModel().gajiListCustomStore,
                filter: null,
                sort: null,
            })
        );

        const dataSourceGajiDireksiList = ref(null);
        const dataSourceGajiTetapList = ref(null);
        const dataSourceGajiCapegList = ref(null);
        const dataSourceGajiHonorList = ref(null);
        const dataSourceGajiKontrakList = ref(null);

 
        const dataSourceGajiDireksiHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiListModel().gajiListCustomStore,
                filter: ['gajis_pegawai_status_id', '=', 1],  // Updated value
            })
        );

        const dataSourceGajiTetapHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiListModel().gajiListCustomStore,
                filter: ['gajis_pegawai_status_id', '=', 2],  // Updated value
              
            })
        );

        const dataSourceGajiCapegHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiListModel().gajiListCustomStore,
                filter: ['gajis_pegawai_status_id', '=', 3],  // Updated value
              
            })
        );

        const dataSourceGajiHonorHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiListModel().gajiListCustomStore,
                filter: ['gajis_pegawai_status_id', '=', 4],  // Updated value
              
            })
        );

        const dataSourceGajiKontrakHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiListModel().gajiListCustomStore,
                filter: ['gajis_pegawai_status_id', '=', 5],  // Updated value
              
            })
        );
        




        // Watch gajiPeriodeId and update dataSourceGajiDireksiList when it changes
        watch(
            gajiPeriodeId,
            (newValue) => {

                // Reinitialize the DataSource when gajiPeriodeId changes
                dataSourceGajiDireksiList.value = new DataSource({
                    requireTotalCount: true,
                    store: useGajiListModel().gajiListCustomStore,
                    filter: [['gajis_pegawai_status_id', '=', 1], 'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                   
                });
                dataSourceGajiTetapList.value = new DataSource({
                    requireTotalCount: true,
                    store: useGajiListModel().gajiListCustomStore,
                    // filter: [[['gajis_pegawai_status_id', '=', 2], 'or', ['gajis_pegawai_status_id', '=', 3]], 'and', ['gaji_periode_id', '=', newValue]]  // Updated value
                    filter: [['gajis_pegawai_status_id', '=', 2], 'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                });

                dataSourceGajiCapegList.value = new DataSource({
                    requireTotalCount: true,
                    store: useGajiListModel().gajiListCustomStore,
                    // filter: [[['gajis_pegawai_status_id', '=', 2], 'or', ['gajis_pegawai_status_id', '=', 3]], 'and', ['gaji_periode_id', '=', newValue]]  // Updated value
                    filter: [['gajis_pegawai_status_id', '=', 3], 'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                });


                dataSourceGajiHonorList.value = new DataSource({
                    requireTotalCount: true,
                    store: useGajiListModel().gajiListCustomStore,
                    filter: [ ['gajis_pegawai_status_id', '=', 4],'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                });
                dataSourceGajiKontrakList.value = new DataSource({
                    requireTotalCount: true,
                    store: useGajiListModel().gajiListCustomStore,
                    filter: [ ['gajis_pegawai_status_id', '=', 5],'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                });


            },
            { immediate: true }  // Ensure it runs immediately when the component is set up
        );


        const setGajiPeriodeId = (data) => {
            
            gajiPeriodeId.value = data;
          };
       
        const loadData = async (filter = null, sort=null) => {
            isLoading.value = true;
            try {
                dataSourceGajiList.value.filter(filter);
                dataSourceGajiList.value.sort(sort);
                // Reload the DataSource with the new filter
                const result = await dataSourceGajiList.value.load();

                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {
            try {
                const result = await dataSourceGajiList.value.store().insert(newItem);
                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };

        const updateData = async (updatedRows) => {
            const store = dataSourceGajiList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
              
                // Wait for all update operations to complete   
                const results = await Promise.all(updatePromises);      
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };


        



        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceGajiList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourceGajiList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourceGajiList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            dataSourceGajiDireksiList,
            dataSourceGajiTetapList,
            dataSourceGajiCapegList,
            dataSourceGajiHonorList,
            dataSourceGajiKontrakList,
            setGajiPeriodeId,
            dataSourceGajiDireksiHistory,
            dataSourceGajiTetapHistory,
            dataSourceGajiCapegHistory,
            dataSourceGajiHonorHistory,
            dataSourceGajiKontrakHistory,
        }
    }
);